import { Col, Row } from 'react-bootstrap';
import { getBoolean, getMedicalStatus, getYesNoUnknown } from './renderers';
import { IDonorRegistration } from '@nkr/models/index';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration
}

const MedicalHistory = (props: IProps) => {
    return (
        <div id='medical-history' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Medical History</span>
                </div>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of High BP?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasHistoryOfHighBp)}
                    </Col>
                </Row>
                {(props.data.hasHistoryOfHighBp == 'Yes' ||
                    props.data.hasHistoryOfHighBp == 'Still being treated') && (
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - # of BP agents:</Col>
                            <Col xs={6} sm={4}>{props.data.highBpAgents}</Col>
                        </Row>
                    )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has History Of CABG (bypass surgery)?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasHadCabg)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Blood Clots?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasHistoryOfBloodClots)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Coronary Disease?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasHistoryOfCoronaryDisease)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Stents Implanted?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasStents)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has History of Chest Pain with Exercise?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.historyChestPainExercise)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has History of Chest Pain at Other Times?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.historyChestPainExercise)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Results of Climbing 2 Flights of Stairs?</Col>
                    <Col xs={6} sm={4}>{getYesNoUnknown(props.data.resultsOfClimbingStairs)}</Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Stress Test within Last Year?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hadStressTestWithinYear)}
                    </Col>
                </Row>
                {props.data.hadStressTestWithinYear == 'Yes' && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Location of Stress Test?</Col>
                            <Col xs={6} sm={4}>{props.data.stressTestLocation}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Results of Stress Test?</Col>
                            <Col xs={6} sm={4}>{props.data.stressTestResults}</Col>
                        </Row>
                    </>
                )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Stroke?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasHadStroke)}
                    </Col>
                </Row>
                {props.data.hasHadStroke == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - # of Strokes</Col>
                        <Col xs={6} sm={4}>{props.data.howManyStrokes}</Col>
                    </Row>
                )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Leg Bypass?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasHadLegBypass)}
                    </Col>
                </Row>
                {props.data.hasHadLegBypass == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - # of Leg Bypasses</Col>
                        <Col xs={6} sm={4}>{props.data.howManyLegBypasses}</Col>
                    </Row>
                )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Lung Disease?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyLungDisease)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of COPD?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasCopd)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of TB?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasTb)}
                    </Col>
                </Row>
                {(
                    props.data.hasTb != 'Unknown'
                ) && (
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is TB Active?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.isTbActive)}
                            </Col>
                        </Row>
                    )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Pneumonia?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyPneumonia)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Respiratory Issues?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasRespiratoryIssues)}
                    </Col>
                </Row>
                {props.data.hasRespiratoryIssues == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - Respiratory Issues:</Col>
                        <Col xs={6} sm={4}>{getYesNoUnknown(props.data.respiratoryIssuesDescription)}</Col>
                    </Row>
                )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Gastro Issues?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasGastroIssues)}
                    </Col>
                </Row>
                {props.data.hasGastroIssues == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - Gastro Issues:</Col>
                        <Col xs={6} sm={4}>{props.data.gastroIssuesDescription}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Gallstones?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyGallstones)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Pancreatitis?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyPancreatitis)}
                    </Col>
                </Row>


                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Liver Disease?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyLiverDisease)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Hepatitis B?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasHepB)}
                    </Col>
                </Row>
                {(props.data.hasHepB != 'Unknown')
                    && (
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is Hep B Active?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.isHepBActive)}
                            </Col>
                        </Row>
                    )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Hepatitis C?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasHepC)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Bleeding Problem?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasBleedingProblem)}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of UTIs?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasHadUti)}
                    </Col>
                </Row>

                {props.data.hasHadUti == 'Yes' && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - UTI episodes:</Col>
                            <Col xs={6} sm={4}>{props.data.utiEpisodes}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Last UTI:</Col>
                            <Col xs={6} sm={4}>
                                {props.data.utiRemissionStatus}
                            </Col>
                        </Row>
                    </>
                )}
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Kidney Damage?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyKidneyDamage)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Proteinuria?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyProteinuria)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Hematuria?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyHematuria)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Neuro Disease?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyNeuroDisease)}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Seizure?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historySeizure)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Lupus?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasLupus)}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Paralysis?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyParalysis)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Arthritis?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasArthritis)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Neuropathy?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyNeuropathy)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Depression?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyDepression)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Anxiety?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.historyAnxiety)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Documented Psychiatric Illness?</Col>
                    <Col xs={6} sm={4}>
                        {getMedicalStatus(props.data.hasHistoryOfPsychiatric)}
                    </Col>
                </Row>
                {
                    (props.data.hasHistoryOfPsychiatric == 'Yes' ||
                        props.data.hasHistoryOfPsychiatric == 'Treated in the past' ||
                        props.data.hasHistoryOfPsychiatric == 'Still being treated') && (
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Description:</Col>
                            <Col xs={6} sm={4}>
                                {props.data.psychiatricDescription}
                            </Col>
                        </Row>
                    )}

                {props.data.gender == 'Female' && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>History of Fibroid Uterus?</Col>
                            <Col xs={6} sm={4}>
                                {getMedicalStatus(props.data.historyFibroidUterus)}
                            </Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>History of Endometriosis?</Col>
                            <Col xs={6} sm={4}>
                                {getMedicalStatus(props.data.historyEndometriosis)}
                            </Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>History of Polycystic Ovaries?</Col>
                            <Col xs={6} sm={4}>
                                {getMedicalStatus(props.data.historyPolycysticOvaries)}
                            </Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>Has had Miscarriages?</Col>
                            <Col xs={6} sm={4}>
                                {getYesNoUnknown(props.data.hasHadMiscarriages)}
                            </Col>
                        </Row>
                        {props.data.hasHadMiscarriages == 'Yes' && (
                            <>
                                <Row className='row-underlined row-value-center'>
                                    <Col xs={6} sm={8} className='item-label'>&nbsp; - # of Miscarriages:</Col>
                                    <Col xs={6} sm={4}>{props.data.howManyMiscarriages}</Col>
                                </Row>
                                <Row className='row-underlined row-value-center'>
                                    <Col xs={6} sm={8} className='item-label'>&nbsp; - Had Late Term Miscarriage?</Col>
                                    <Col xs={6} sm={4}>
                                        {getBoolean(props.data.hadLateMiscarriage)}
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>Has had Abortions?</Col>
                            <Col xs={6} sm={4}>
                                {getYesNoUnknown(props.data.hasHadAbortions)}
                            </Col>
                        </Row>
                        {props.data.hasHadAbortions == 'Yes' && (
                            <>
                                <Row className='row-underlined row-value-center'>
                                    <Col xs={6} sm={8} className='item-label'>&nbsp; - # of Abortions:</Col>
                                    <Col xs={6} sm={4}>{props.data.howManyAbortions}</Col>
                                </Row>
                            </>
                        )}

                    </>)
                }

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Transfusions?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasReceivedTransfusion)}
                    </Col>
                </Row>

                {props.data.hasReceivedTransfusion == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - # of Transfusions:</Col>
                        <Col xs={6} sm={4}>{props.data.howManyTransfusions}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Obesity?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasHistoryOfObesity)}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Fabry's Disease?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasFabrys)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Sickle Cell Disease?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasSickleCell)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Sickle Cell Trait?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasSickleCellTrait)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Sarcoidosis?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasSarcoidosis)}
                    </Col>
                </Row>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>History of Auto-Immune Disease</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasAutoImmune)}
                    </Col>
                </Row>
                {props.data.hasAutoImmune == 'Yes' && (<>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - Auto-Immune Description:</Col>
                        <Col xs={6} sm={4}>
                            {getYesNoUnknown(props.data.autoImmuneDescription)}
                        </Col>
                    </Row>
                </>)}

                {props.data.lastPhysicalExam != null ? (<>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>Last Physical Exam?</Col>
                        <Col xs={6} sm={4}>{props.data.lastPhysicalExam}</Col>
                    </Row>
                </>) : (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>Has had Physical Exam?</Col>
                            <Col xs={6} sm={4}>
                                {getYesNoUnknown(props.data.hasHadPhysicalExam, false)}
                            </Col>
                        </Row>
                        {props.data.hasHadPhysicalExam == 'Yes' && (<>
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8} className='item-label'>&nbsp; - how many years ago:</Col>
                                <Col xs={6} sm={4}>{props.data.physicalExamYearsAgo}</Col>
                            </Row>
                        </>)}
                    </>
                )}

                {props.data.gender == 'Female' ? (
                    <>
                        {props.data.lastMammogram ? (<>
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8} className='item-label'>Last Mammogram?</Col>
                                <Col xs={6} sm={4}>{props.data.lastMammogram}</Col>
                            </Row>
                        </>) : (
                            <>
                                <Row className='row-underlined row-value-center'>
                                    <Col xs={6} sm={8} className='item-label'>Has had Mammogram?</Col>
                                    <Col xs={6} sm={4}>
                                        {getYesNoUnknown(props.data.hasHadMammogram, false)}
                                    </Col>
                                </Row>
                                {props.data.hasHadMammogram && (<>
                                    <Row className='row-underlined row-value-center'>
                                        <Col xs={6} sm={8} className='item-label'>&nbsp; - how many years ago:</Col>
                                        <Col xs={6} sm={4}>{props.data.mammogramYearsAgo}</Col>
                                    </Row>
                                </>)}
                            </>
                        )}

                        {props.data.lastPapSmear ? (
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8} className='item-label'>Last Pap Smear?</Col>
                                <Col xs={6} sm={4}>{props.data.lastPapSmear}</Col>
                            </Row>
                        ) : (
                            <>
                                <Row className='row-underlined row-value-center'>
                                    <Col xs={6} sm={8} className='item-label'>Has had Pap Smear?</Col>
                                    <Col xs={6} sm={4}>
                                        {getYesNoUnknown(props.data.hasHadPapSmear, false)}
                                    </Col>
                                </Row>

                                {props.data.hasHadPapSmear && (
                                    <Row className='row-underlined row-value-center'>
                                        <Col xs={6} sm={8} className='item-label'>&nbsp; - how many years ago:</Col>
                                        <Col xs={6} sm={4}>{props.data.papSmearYearsAgo}</Col>
                                    </Row>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {props.data.lastPsaTest ? (
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8} className='item-label'>Last PSA Test?</Col>
                                <Col xs={6} sm={4}>{props.data.lastPsaTest}</Col>
                            </Row>
                        ) : (
                            <>
                                <Row className='row-underlined row-value-center'>
                                    <Col xs={6} sm={8} className='item-label'>Has had PSA Test?</Col>
                                    <Col xs={6} sm={4}>
                                        {getYesNoUnknown(props.data.hasHadPsaTest, false)}
                                    </Col>
                                </Row>
                                {props.data.hasHadPsaTest == 'Yes' && (
                                    <Row className='row-underlined row-value-center'>
                                        <Col xs={6} sm={8} className='item-label'>&nbsp; - how many years ago:</Col>
                                        <Col xs={6} sm={4}>{props.data.psaTestYearsAgo}</Col>
                                    </Row>
                                )}
                            </>
                        )}
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Colonoscopy?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.hasHadColonoscopy, false)}
                    </Col>
                </Row>
                {props.data.hasHadColonoscopy == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - How Many Years Ago:</Col>
                        <Col xs={6} sm={4}>{props.data.colonoscopyYearsAgo}</Col>
                    </Row>
                )}
            </div>
        </div>
    );
}

export default MedicalHistory;